var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQa = function SvgQa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8d1b3d",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v480h158.4l97.745-26.666-97.745-26.668L256.145 400 158.4 373.334l97.745-26.668L158.4 320l97.745-26.666-97.745-26.668L256.145 240 158.4 213.334l97.745-26.668L158.4 160l97.745-26.666-97.745-26.668L256.145 80 158.4 53.334l97.745-26.668L158.4 0H0z",
    fill: "#fff"
  })));
};
export default __webpack_public_path__ + "assets/cd4ff8c2e62bf6e332b69f31b36d1d17.svg";
export { SvgQa as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/qa.svg